import { render, staticRenderFns } from "./our-team.vue?vue&type=template&id=42d2aa5d&"
import script from "./our-team.vue?vue&type=script&lang=js&"
export * from "./our-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports